import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { deleteListingFromCart } from "../actions/cart";

const CartListingCard = ({ deleteListingFromCart, listing }) => {
  return (
    <Container>
      <div className='itemsList'>
        <div className='item'>
          <h2>{listing.name}</h2>
          <label className='label'>
            Qty{" "}
            <select
              defaultValue='1'
              name='quantity'
              //onChange={handleChange}
              data-cy='quantity'
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </label>
          <h2>{listing.price}</h2>
          <button
            onClick={() => deleteListingFromCart(listing.id)}
            className='deleteButton'
            data-cy='delete'
          >
            Delete
          </button>
        </div>
      </div>
    </Container>
  );
};

export default connect(null, { deleteListingFromCart })(CartListingCard);

const Container = styled.div`
  box-sizing: border-box;
  width: 50rem;
  display: flex;
  text-align: center;
  align-items: center;
  max-width: 100%;
  margin: auto;
  overflow: hidden;
  padding: 2rem;
  margin-bottom: 3rem;
  border: black 0.1rem solid;

  .itemsList {
    display: flex;
    width: 70%;
  }

  .item {
    justify-content: space-around;
    align-items: center;
    padding: 1rem;
    border: black 1px solid;
    display: flex;
    width: 80%;
  }

  .label {
    display: flex;
    align-items: center;
  }

  .itemsTotal {
    border: black 1px solid;
    width: 30%;
  }

  .deleteButton {
    width: 3rem;
  }

  button {
    width: 7rem;
    margin: 0.5rem;
  }
`;
